import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private PickingPositions Types */
import {
  _PickingPosition
} from '../namespace-helper'

import _ from 'lodash'

const selectedPickingPositionTemplate = {
  id: 0,
  invoice_position: {
    product: {
      id: 0,
      reference: null,
      product_description: {},
      manufacturer: {
        name: null
      }
    }
  }

}
export default {
  namespaced: true,
  state: {
    selectedPickingPosition: _.cloneDeep(selectedPickingPositionTemplate),
    pickingPositions: [],
    pickingPositionLoading: false,
    pickingPositionRemoving: false,
    openDialog: false
  },
  mutations: {
    [_PickingPosition.mutations.setSelectedPickingPosition] (state, payload) {
      if (payload !== null) {
        state.selectedPickingPosition = payload
      } else {
        state.selectedPickingPosition = _.cloneDeep(selectedPickingPositionTemplate)
      }
    },
    [_PickingPosition.mutations.setPickingPositions] (state, payload) {
      state.pickingPositions = payload
    },
    [_PickingPosition.mutations.setRemovingPickingPosition] (state, payload) {
      state.pickingPositionRemoving = payload
    },
    [_PickingPosition.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    }
  },
  actions: {
    [_PickingPosition.actions.savePickingPosition] (context, payload) {
      const data = JSON.stringify(payload)

      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/pickingPositions'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/pickingPositions/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_PickingPosition.actions.loadPickingPositionForPicking] (context, payload) {
      var url = API_URL + '/api/v1/pickingPositions/picking/' + payload.id

      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          context.commit(_PickingPosition.mutations.setPickingPositions, r.data.data)
          resolve(r)
        }, function (err) {
          context.commit(_PickingPosition.mutations.setPickingPositions, null)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_PickingPosition.actions.deletePickingPosition] (context, payload) {
      context.commit(_PickingPosition.mutations.setRemovingPickingPosition, true)

      var url = API_URL + '/api/v1/pickingPositions/' + payload.id

      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_PickingPosition.mutations.setRemovingPickingPosition, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          context.commit(_PickingPosition.mutations.setRemovingPickingPosition, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_PickingPosition.actions.setSelectedPickingPosition] (context, payload) {
      context.commit(_PickingPosition.mutations.setSelectedPickingPosition, payload)
    },
    [_PickingPosition.actions.clearPickingPositions] (context, payload) {
      context.commit(_PickingPosition.mutations.setPickingPositions, [])
    },
    [_PickingPosition.actions.openCloseDialog] ({ commit }) {
      commit(_PickingPosition.mutations.setOpenCloseDialogState)
    },
    [_PickingPosition.actions.resetState] (context, payload) {
      context.commit(_PickingPosition.mutations.setPickingPositions, [])
      context.commit(_PickingPosition.mutations.setSelectedPickingPosition, null)
    }

  },
  getters: {
    [_PickingPosition.getters.pickingPositions] (state) {
      return state.pickingPositions
    },
    [_PickingPosition.getters.getSelectedPickingPosition] (state) {
      return state.selectedPickingPosition
    },
    [_PickingPosition.getters.getOpenDialogState] (state) {
      return state.openDialog
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/PickingPosition/pickingPositions.js